import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { allDeliveryMen } from 'app/mocks/data/users/deliveryMen'

import { api } from 'app/utils/constants'

import { DeliveryMan, DeliveryManPayload } from 'app/types/users/deliveryMan'

export const updateDeliveryMan = http.patch(
    `${process.env.REACT_APP_API_ADDRESS}/${api.users.deliveryMen.DETAILS}`,
    async ({ params, request }) => {
        const { id } = params

        const payload = await request.json()
        const payloadParsed = DeliveryManPayload.safeParse(payload)

        const deliveryManFound = allDeliveryMen.find(
            (deliveryMan) => deliveryMan.id.toString() === id,
        )

        // Wrong data
        if (!payloadParsed.success) {
            return HttpResponse.json(payloadParsed.error.issues, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        // Not found
        if (!deliveryManFound) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.NOT_FOUND,
            })
        }

        return HttpResponse.json<DeliveryMan>({
            ...deliveryManFound,
            ...payloadParsed.data,
            client: deliveryManFound.client,
        })
    },
)
